import { render, staticRenderFns } from "./faysalBeneficiaryComponent.vue?vue&type=template&id=95f7dd52&"
import script from "./faysalBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./faysalBeneficiaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports